export enum PermissionDeliveryOption {
  DELIVERY_COMMON_LOGIN = 'domicilios',
  DELIVERY_POINT_LIST = '/puntos/lista',
  DELIVERY_POINT_FILTER = 'delivery.point.filter',
  DELIVERY_POINT_CREATE = '/puntos/crear',
  DELIVERY_POINT_EDIT = '/puntos/modificar',
  DELIVERY_POINT_ACTIVATE_OR_INACTIVATE = 'delivery.point.activateOrInactivate',
  DELIVERY_ORDER_LIST = '/domicilios/pedidos-en-curso',
  DELIVERY_ORDER_FILTER_POINT = 'domi.order.filterPoint',
  DELIVERY_ORDER_DETAIL = 'delivery.order.detail',
  DELIVERY_ORDER_SHOW_TOTAL_SERVICE = 'delivery.order.showTotalService',
  DELIVERY_ORDER_CREATE = '/domicilios/crear',
  DELIVERY_ORDER_SHOW_ORDER_TYPE = 'delivery.order.showOrderType',
  DELIVERY_ORDER_EDIT_ACTION = 'delivery.order.editAction',
  DELIVERY_ORDER_EDIT = '/domicilios/modificar',
  DELIVERY_ORDER_DUPLICATE_ACTION = 'delivery.order.duplicateAction',
  DELIVERY_ORDER_SHOW_EVIDENCE_ACTION = 'delivery.order.showEvidenceAction',
  DELIVERY_ORDER_RATE_ACTION = 'delivery.order.rateAction',
  DELIVERY_ORDER_CANCEL_ACTION = 'delivery.order.cancelAction',
  DELIVERY_ORDER_HIDE_ORDER_TYPE = 'delivery.order.hideOrderType',
  DELIVERY_ORDER_PROGRAM = 'delivery.order.program',
  DELIVERY_ORDER_ADD_ROUND_TRIP = 'delivery.order.addRoundTrip',
  DELIVERY_ORDER_ADD_ROUND_TRIP_121 = 'delivery.order.addRoundTrip',
  DELIVERY_ORDER_ADD_ADDRESS = 'delivery.order.addAddress',
  DELIVERY_ORDER_HIDE_ADD_ADDRESS = 'delivery.order.hideAddAddress',
  DELIVERY_ORDER_ADD_TRANSFER = 'delivery.order.addTransfer',
  DELIVERY_ORDER_HIDE_GEOREFERENCER = 'delivery.order.hideGeoreferencer',
  DELIVERY_ORDER_SHOW_GEOREFERENCER = 'delivery.order.showGeoreferencer',
  DELIVERY_ORDER_DELETE = 'delivery.order.delete',
  DELIVERY_ORDER_VIEW_TRACK = 'delivery.order.viewTrack',
  DELIVERY_ORDER_REMOVE_CHAT = 'delivery.order.removeChat',
  DELIVERY_ORDER_UNLIMITED_DECLARED_VALUE = 'delivery.order.unlimitedDeclaredValue',
  DELIVERY_ORDER_SHOW_NEW_SERVICES = 'delivery.order.showNewServices',
  DELIVERY_ORDER_HIDE_CREATE = 'domi.order.hideCreate',
  // DELIVERY_COLLECTION_RECEIPTS = '/recaudos/historial'
}
